// react
import { useTranslation } from "react-i18next";
// node-modules
// mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  useTheme,
  styled,
} from "@mui/material";
// src

type Props = {
  id: number;
  deleteMeasurementResult: (index: number) => void;
  deleteMeasurementResultDialogDisplayed: boolean;
  closeDeleteMeasurementResultDialog: () => void;
};

const DeleteMeasurementResultDialog = (props: Props) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customModalColor = {
    color: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customLoadingButtonColor = {
    backgroundColor: theme.palette.btn.error.backgroundColor,
    boxShadow: "none",
  };

  const CustomCanselButton = styled(Button)({
    background: theme.palette.base.modal,
    color: theme.palette.base.contrast,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  return (
    <Dialog
      open={props.deleteMeasurementResultDialogDisplayed}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        className: "del-dialog4",
        style: {
          background: customModalColor.color,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: customDialogBackgroundColor.color,
          },
        },
      }}
    >
      <DialogTitle
        style={customColor}
        className="title-name"
        id="alert-dialog-title"
      >
        {t("DELETE_MEASUREMENT_RESULT")}
        <Button
          style={customColor}
          className="x-btn btn-remove"
          onClick={props.closeDeleteMeasurementResultDialog}
        >
          ×
        </Button>
        <div className="border-comm" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={customColor} className="del-dialog5">
          {t("CONFIRM_DELETE_MEASUREMENT_RESULT")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CustomCanselButton
          size="small"
          variant="contained"
          onClick={props.closeDeleteMeasurementResultDialog}
          className="del-dialog6"
        >
          {t("CANCEL")}
        </CustomCanselButton>
        <Button
          style={customLoadingButtonColor}
          size="small"
          variant="contained"
          onClick={() => {
            props.closeDeleteMeasurementResultDialog();
            props.deleteMeasurementResult(props.id);
          }}
          className="del-dialog7"
        >
          {t("REMOVE")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMeasurementResultDialog;
